import { httpMultipleActionsReducer, reduceReducers } from "../lib/create-action";
import { GET_EPISODE } from "../actions/episodes";
import get from "lodash/get";
import { EPISODE_PUT_SUCCESS, SHOW_EPISODE_FETCH_SUCCESS } from "../actions/shows";
import { UPLOAD_TO_YOUTUBE } from "../action_managers/shows";

const getEpisode = httpMultipleActionsReducer(
  [GET_EPISODE, SHOW_EPISODE_FETCH_SUCCESS, UPLOAD_TO_YOUTUBE, EPISODE_PUT_SUCCESS],
  { episodeByUUID: {} },
  {
    success: (state, action) => {
      const currentEpisodes = get(state, "episodeByUUID", {});
      const episode = action.payload.resp;
      const newEpisodes = { ...currentEpisodes, [episode.uuid]: episode };
      return {
        ...state,
        episodeByUUID: newEpisodes,
      };
    },
  }
);

export default reduceReducers(getEpisode);
